import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export default function TestimonialSwiperWithFlip() {
  const [[activeIndex, direction], setActiveIndex] = useState([0, 0]);

  const data = [
    {
      image: "/images/home/team/Laura.JPG",
      description: "J'ai passé plus de 15 ans dans l'hôtellerie de luxe et les maisons privées, où j'ai appris que le vrai luxe, c'est l'attention portée aux détails... et la confiance.",
      content: "C'est ce qui m'a donné envie de créer Les Clés Conciergerie : une conciergerie à taille humaine, où chaque client est unique, et chaque maison est accueillie avec soin.",
      objective: "Aujourd'hui, mon objectif, c'est d'offrir ce même niveau d'exigence et de bienveillance à nos propriétaires et à leurs voyageurs. Parce qu'au fond, prendre soin des autres, c'est ce que je fais depuis toujours.",
      author: "Laura",
    },
    {
      image: "/images/home/team/Lionel.JPG",
      description: "À 45 ans, fort de plus de vingt ans d’expérience en direction d’entreprises dans le BTP, la menuiserie et le désamiantage, je continue de piloter une société spécialisée dans le bâtiment.",
      content: "Nous avons récemment fondé Les clés conciergerie;  une conciergerie haut de gamme destinée à accompagner les propriétaires d’appartements et de villas.",
      objective: "Mon ambition : offrir un service irréprochable, personnalisé et digne de la confiance qui m’est accordée.",
      author: "Lionel",
    },
    {
      image: "/images/home/team/Manon.JPG",
      description: "Diplômée d’un Bachelor en business et marketing, j’ai développé une expertise orientée service, organisation et gestion d’équipes.",
      content: "Répondre efficacement aux demandes et structurer des solutions sur mesure a toujours guidé ma vision professionnelle.",
      objective: "C’est cette exigence partagée qui nous a conduits à créer une conciergerie, afin d’offrir un accompagnement fiable, rigoureux et pensé pour répondre aux besoins de chaque client.",
      author: "Manon",
    },
  ];

  const slide = (newDirection) => {
    setActiveIndex((prevIndex) => [prevIndex[0] + newDirection, newDirection]);
  };

  // Calcul de l'index réel (boucle infinie)
  const index = ((activeIndex % data.length) + data.length) % data.length;

  // On prend toujours 3 éléments dans l'ordre correct
  const visibleItems = [...data, ...data].slice(
    index,
    index + 3
  );

  return (
    <div className="flex flex-col items-center pb-24">
      <div className="flex flex-row items-center justify-end">
        <AnimatePresence mode="popLayout" initial={false}>
          {visibleItems.map((tag) => (
            <motion.div
              className="card"
              key={tag.author}
              layout
              custom={{
                direction,
                position: () => {
                  if (tag === visibleItems[0]) {
                    return "left";
                  } else if (tag === visibleItems[1]) {
                    return "center";
                  } else {
                    return "right";
                  }
                },
              }}
              variants={cardVariants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ duration: 1 }}
            >
              <FlipCard item={tag} isActive={1} />
            </motion.div>
          ))}
        </AnimatePresence>

        {/* Flèches */}
        <button
          onClick={() => slide(-1)}
          className="absolute left-10 z-10 p-4 bg-white rounded-full shadow-lg hover:scale-110 transition"
        >
          <img src="/images/Icon/arrow-left.svg" className="w-8 h-8" alt="précédent" />
        </button>
        <button
          onClick={() => slide(1)}
          className="absolute right-10 z-10 p-4 bg-white rounded-full shadow-lg hover:scale-110 transition"
        >
          <img src="/images/Icon/arrow-right.svg" className="w-8 h-8" alt="suivant" />
        </button>
      </div>

      {/* Dots
      <div className="flex gap-4 mt-12">
        {data.map((_, i) => (
          <div
            key={i}
            className={`h-2 rounded-full transition-all duration-300 ${
              i === 1 ? "bg-indigo-600 w-12" : "bg-gray-400 w-3"
            }`}
          />
        ))}
      </div> */}
    </div>
  );
}

const cardVariants = {
  enter: ({ direction }) => ({
    x: direction > 0 ? 800 : -800,
    opacity: 0,
    scale: 0.7,
  }),
  center: ({ position }) => ({
    x: position() === "left" ? -130 : position() === "right" ? 130 : 0,
    scale: position() === "center" ? 1.1 : 0.8,
    zIndex: position() === "center" ? 10 : 5,
    opacity: 1,
  }),
  exit: ({ direction }) => ({
    x: direction > 0 ? -800 : 800,
    opacity: 0,
    scale: 0.7,
    zIndex: 0,
  }),
};

function FlipCard({ item, isActive }) {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      className="w-80 h-[500px] cursor-pointer"
      style={{ perspective: "1200px" }}
      onMouseEnter={() => isActive && setFlipped(true)}
      onMouseLeave={() => isActive && setFlipped(false)}
      onClick={() => isActive && setFlipped(!flipped)}
    >
      {/* Face avant */}
      <motion.div
        className="absolute inset-0 rounded-3xl shadow-2xl overflow-hidden bg-white"
        style={{ backfaceVisibility: "hidden" }}
        animate={{ rotateY: flipped ? 180 : 0 }}
        transition={{ duration: 0.8 }}
      >
        <img src={item.image} alt={item.author} className="w-full h-full object-cover" />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 p-8">
          <h3 className="text-3xl font-bold text-white">{item.author}</h3>
        </div>
      </motion.div>

      {/* Face arrière */}
      <motion.div
        className="absolute inset-0 rounded-3xl shadow-2xl bg-[#fff6e2] p-10 text-white flex flex-col justify-center"
        style={{ backfaceVisibility: "hidden", rotateY: "180deg" }}
        animate={{ rotateY: flipped ? 0 : -180 }}
        transition={{ duration: 0.8 }}
      >
        <div className="space-y-3">
          <p className="text-base leading-relaxed">{item.description}</p>
          <p className="text-base leading-relaxed">{item.content}</p>
          <p className="text-base leading-relaxed">{item.objective}</p>
        </div>
        <p className="text-right text-1xl font-bold">— {item.author}</p>
      </motion.div>
    </div>
  );
}